export default __webpack_public_path__ + "static/media/london_xl.41d7945f.jpg";